import React, { type ReactElement } from 'react';

interface IconStars48Props {
  width?: number;
  height?: number;
  className?: string;
}

export function IconStars48({
  width = 105,
  height = 21,
  className,
}: IconStars48Props): ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox="0 0 105 21"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M11.3411 3.50738C11.0206 2.60932 9.7445 2.62677 9.44866 3.53327L8.2843 7.10102C8.15004 7.51241 7.76639 7.79077 7.33365 7.79077H3.3656C2.43772 7.79077 2.01015 8.94473 2.714 9.54933L6.21964 12.5606C6.52191 12.8203 6.64118 13.2346 6.52323 13.6152L5.29606 17.5751C5.01236 18.4906 6.05455 19.2422 6.83366 18.684L9.98009 16.4297C10.3404 16.1716 10.8278 16.1814 11.1773 16.454L14.2261 18.8308C14.9934 19.429 16.0764 18.6904 15.7996 17.7577L14.5594 13.5792C14.4448 13.193 14.5731 12.7757 14.8849 12.5207L18.4982 9.56477C19.2256 8.96969 18.8048 7.79077 17.865 7.79077H13.5748C13.1521 7.79077 12.775 7.525 12.633 7.12691L11.3411 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M32.3411 3.50738C32.0206 2.60932 30.7445 2.62677 30.4487 3.53327L29.2843 7.10102C29.15 7.51241 28.7664 7.79077 28.3336 7.79077H24.3656C23.4377 7.79077 23.0101 8.94473 23.714 9.54933L27.2196 12.5606C27.5219 12.8203 27.6412 13.2346 27.5232 13.6152L26.2961 17.5751C26.0124 18.4906 27.0546 19.2422 27.8337 18.684L30.9801 16.4297C31.3404 16.1716 31.8278 16.1814 32.1773 16.454L35.2261 18.8308C35.9934 19.429 37.0764 18.6904 36.7996 17.7577L35.5594 13.5792C35.4448 13.193 35.5731 12.7757 35.8849 12.5207L39.4982 9.56477C40.2256 8.96969 39.8048 7.79077 38.865 7.79077H34.5748C34.1521 7.79077 33.775 7.525 33.633 7.12691L32.3411 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M53.3411 3.50738C53.0206 2.60932 51.7445 2.62677 51.4487 3.53327L50.2843 7.10102C50.15 7.51241 49.7664 7.79077 49.3336 7.79077H45.3656C44.4377 7.79077 44.0101 8.94473 44.714 9.54933L48.2196 12.5606C48.5219 12.8203 48.6412 13.2346 48.5232 13.6152L47.2961 17.5751C47.0124 18.4906 48.0546 19.2422 48.8337 18.684L51.9801 16.4297C52.3404 16.1716 52.8278 16.1814 53.1773 16.454L56.2261 18.8308C56.9934 19.429 58.0764 18.6904 57.7996 17.7577L56.5594 13.5792C56.4448 13.193 56.5731 12.7757 56.8849 12.5207L60.4982 9.56477C61.2256 8.96969 60.8048 7.79077 59.865 7.79077H55.5748C55.1521 7.79077 54.775 7.525 54.633 7.12691L53.3411 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M74.3411 3.50738C74.0206 2.60932 72.7445 2.62677 72.4487 3.53327L71.2843 7.10102C71.15 7.51241 70.7664 7.79077 70.3336 7.79077H66.3656C65.4377 7.79077 65.0101 8.94473 65.714 9.54933L69.2196 12.5606C69.5219 12.8203 69.6412 13.2346 69.5232 13.6152L68.2961 17.5751C68.0124 18.4906 69.0546 19.2422 69.8337 18.684L72.9801 16.4297C73.3404 16.1716 73.8278 16.1814 74.1773 16.454L77.2261 18.8308C77.9934 19.429 79.0764 18.6904 78.7996 17.7577L77.5594 13.5792C77.4448 13.193 77.5731 12.7757 77.8849 12.5207L81.4982 9.56477C82.2256 8.96969 81.8048 7.79077 80.865 7.79077H76.5748C76.1521 7.79077 75.775 7.525 75.633 7.12691L74.3411 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M95.3411 3.50738C95.0206 2.60932 93.7445 2.62677 93.4487 3.53327L92.2843 7.10102C92.15 7.51241 91.7664 7.79077 91.3336 7.79077H87.3656C86.4377 7.79077 86.0101 8.94473 86.714 9.54933L90.2196 12.5606C90.5219 12.8203 90.6412 13.2346 90.5232 13.6152L89.2961 17.5751C89.0124 18.4906 90.0546 19.2422 90.8337 18.684L93.9801 16.4297C94.3404 16.1716 94.8278 16.1814 95.1773 16.454L98.2261 18.8308C98.9934 19.429 100.076 18.6904 99.7996 17.7577L98.5594 13.5792C98.4448 13.193 98.5731 12.7757 98.8849 12.5207L102.498 9.56477C103.226 8.96969 102.805 7.79077 101.865 7.79077H97.5748C97.1521 7.79077 96.775 7.525 96.633 7.12691L95.3411 3.50738Z"
        fill="#1D1D1B"
        fillRule="evenodd"
      />
      <mask
        height="18"
        id="mask0_3439_23988"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="17"
        x="86"
        y="2"
      >
        <path
          clipRule="evenodd"
          d="M95.3411 3.50738C95.0206 2.60932 93.7445 2.62677 93.4487 3.53327L92.2843 7.10102C92.15 7.51241 91.7664 7.79077 91.3336 7.79077H87.3656C86.4377 7.79077 86.0101 8.94473 86.714 9.54933L90.2196 12.5606C90.5219 12.8203 90.6412 13.2346 90.5232 13.6152L89.2961 17.5751C89.0124 18.4906 90.0546 19.2422 90.8337 18.684L93.9801 16.4297C94.3404 16.1716 94.8278 16.1814 95.1773 16.454L98.2261 18.8308C98.9934 19.429 100.076 18.6904 99.7996 17.7577L98.5594 13.5792C98.4448 13.193 98.5731 12.7757 98.8849 12.5207L102.498 9.56477C103.226 8.96969 102.805 7.79077 101.865 7.79077H97.5748C97.1521 7.79077 96.775 7.525 96.633 7.12691L95.3411 3.50738Z"
          fill="white"
          fillRule="evenodd"
        />
      </mask>
      <g mask="url(#mask0_3439_23988)">
        <rect fill="#F3F3F0" height="17" rx="1" width="4" x="100" y="3" />
      </g>
    </svg>
  );
}
